// 文件路径: public/js/procurementData.js

const mockOutsourceList = [
    {
        "requirement_id": "REQ-001",
        "item_type": "图书",
        "required_title": "中国古典文学概论",
        "required_author": "张三",
        "required_isbn": "978-7-5063-8472-3",
        "required_publisher": "商务印书馆",
        "required_quantity": 200,
        "required_edition": "2020年修订版",
        "status": "未匹配",
        "match_details": null,
        "notes": "此书为指定教材，版本必须完全一致。"
    },
    {
        "requirement_id": "REQ-002",
        "item_type": "内容",
        "required_title": "《大明王朝1566》影视剧本",
        "required_author": "刘和平",
        "required_isbn": null,
        "required_publisher": null,
        "required_quantity": 1,
        "required_edition": "唯一正版",
        "status": "已匹配",
        "match_details": {
            "match_source_name": "北京磨铁文化",
            "match_source_id": "Supplier-MT-001",
            "matched_title": "大明王朝1566（典藏版）",
            "matched_author": "刘和平",
            "matched_isbn": "978-7-5500-1111-1",
            "matched_price_unit": 68.00,
            "match_time": "2025-08-28T10:30:00Z"
        },
        "notes": "需采购其独家授权的纸质出版物版本。"
    },
    {
        "requirement_id": "REQ-003",
        "item_type": "图书",
        "required_title": "Python编程从入门到精通",
        "required_author": "赵丽",
        "required_isbn": "978-7-111-54321-0",
        "required_publisher": "机械工业出版社",
        "required_quantity": 500,
        "required_edition": "最新版",
        "status": "匹配失败",
        "match_details": {
            "fail_reason": "市场上该版本断货，需寻找替代方案。",
            "last_attempt_time": "2025-08-29T15:45:00Z"
        },
        "notes": "这是一本热门技术图书，需求量大，出版社可能缺货。"
    },
    {
        "requirement_id": "REQ-004",
        "item_type": "图书",
        "required_title": "儿童绘本：小猪佩奇系列",
        "required_author": "Astley Baker Davies",
        "required_isbn": null,
        "required_publisher": "中信出版社",
        "required_quantity": 100,
        "required_edition": "全套",
        "status": "部分匹配",
        "match_details": {
            "match_source_name": "当当网供应商",
            "matched_title": "小猪佩奇全套绘本（第一辑）",
            "matched_isbn": "978-7-5555-6666-0",
            "matched_quantity": 50,
            "matched_price_unit": 35.00,
            "match_time": "2025-08-29T11:00:00Z"
        },
        "notes": "全套包含多辑，目前只匹配到第一辑。仍需寻找其他辑。"
    },
    {
        "requirement_id": "REQ-005",
        "item_type": "图片",
        "required_title": "《清明上河图》高分辨率电子版",
        "required_author": "张择端",
        "required_isbn": null,
        "required_publisher": null,
        "required_quantity": 1,
        "required_edition": "授权使用版",
        "status": "未匹配",
        "match_details": null,
        "notes": "需要从故宫博物院等机构获取正版授权。"
    },
    {
        "requirement_id": "REQ-006",
        "item_type": "图书",
        "required_title": "如何有效沟通：提高人际交往能力",
        "required_author": "李明",
        "required_isbn": "978-7-112-99887-7",
        "required_publisher": "中国人民大学出版社",
        "required_quantity": 80,
        "required_edition": "2022年最新版",
        "status": "未匹配",
        "match_details": null,
        "notes": "客户急需此书作为培训用书，需尽快匹配。"
    },
    {
        "requirement_id": "REQ-007",
        "item_type": "期刊",
        "required_title": "《经济学人》2025年全年合订本",
        "required_author": null,
        "required_isbn": null,
        "required_publisher": "经济学人集团",
        "required_quantity": 1,
        "required_edition": "中文版",
        "status": "已匹配",
        "match_details": {
            "match_source_name": "中图公司",
            "match_source_id": "Supplier-CT-005",
            "matched_title": "《经济学人》中文版2025全年订",
            "matched_author": null,
            "matched_isbn": null,
            "matched_price_unit": 3800.00,
            "match_time": "2025-08-29T16:00:00Z"
        },
        "notes": "已与中图公司确认，并获得订阅报价。"
    },
    {
        "requirement_id": "REQ-008",
        "item_type": "图书",
        "required_title": "算法导论",
        "required_author": "Thomas H. Cormen",
        "required_isbn": "978-7-111-40701-1",
        "required_publisher": "机械工业出版社",
        "required_quantity": 350,
        "required_edition": "第3版",
        "status": "部分匹配",
        "match_details": {
            "match_source_name": "亚马逊供应商",
            "match_source_id": "Supplier-AMZ-010",
            "matched_title": "算法导论（原书第3版）",
            "matched_isbn": "978-7-111-40701-1",
            "matched_quantity": 150,
            "matched_price_unit": 139.00,
            "match_time": "2025-08-30T09:00:00Z"
        },
        "notes": "首批采购150本，剩余数量待其他供应商报价。"
    },
    {
        "requirement_id": "REQ-009",
        "item_type": "电子资源",
        "required_title": "IEEE Xplore数据库访问权",
        "required_author": null,
        "required_isbn": null,
        "required_publisher": "IEEE",
        "required_quantity": 1,
        "required_edition": "1年授权",
        "status": "未匹配",
        "match_details": null,
        "notes": "需要联系官方代理商获取报价，并确认授权范围。"
    },
    {
        "requirement_id": "REQ-010",
        "item_type": "图书",
        "required_title": "三体全集",
        "required_author": "刘慈欣",
        "required_isbn": "978-7-5366-9289-0",
        "required_publisher": "重庆出版社",
        "required_quantity": 50,
        "required_edition": "精装版",
        "status": "已匹配",
        "match_details": {
            "match_source_name": "新华书店总店",
            "match_source_id": "Supplier-XH-001",
            "matched_title": "三体全集（精装版）",
            "matched_author": "刘慈欣",
            "matched_isbn": "978-7-5366-9289-0",
            "matched_price_unit": 168.00,
            "match_time": "2025-08-29T14:20:00Z"
        },
        "notes": "已询价并确认库存，可按时发货。"
    },
    {
        "requirement_id": "REQ-011",
        "item_type": "图书",
        "required_title": "Java核心技术 卷I",
        "required_author": "Cay S. Horstmann",
        "required_isbn": "978-7-111-54705-8",
        "required_publisher": "机械工业出版社",
        "required_quantity": 120,
        "required_edition": "原书第11版",
        "status": "未匹配",
        "match_details": null,
        "notes": "指定版本，不能使用替代版本。"
    },
    {
        "requirement_id": "REQ-012",
        "item_type": "音像制品",
        "required_title": "世界名曲集-CD套装",
        "required_author": null,
        "required_isbn": null,
        "required_publisher": null,
        "required_quantity": 5,
        "required_edition": "典藏版",
        "status": "未匹配",
        "match_details": null,
        "notes": "需确认包含曲目列表，并核实版权。"
    },
    {
        "requirement_id": "REQ-013",
        "item_type": "图书",
        "required_title": "红楼梦（校注本）",
        "required_author": "曹雪芹 / 脂砚斋",
        "required_isbn": "978-7-101-08147-3",
        "required_publisher": "人民文学出版社",
        "required_quantity": 150,
        "required_edition": "2018年版",
        "status": "已匹配",
        "match_details": {
            "match_source_name": "京东图书供应商",
            "match_source_id": "Supplier-JD-002",
            "matched_title": "红楼梦（校注本全三册）",
            "matched_isbn": "978-7-101-08147-3",
            "matched_price_unit": 98.00,
            "match_time": "2025-08-30T10:15:00Z"
        },
        "notes": "客户指定此版本，已确认供应商库存充足。"
    },
    {
        "requirement_id": "REQ-014",
        "item_type": "电子资源",
        "required_title": "中国知网数据库",
        "required_author": null,
        "required_isbn": null,
        "required_publisher": "中国知网",
        "required_quantity": 1,
        "required_edition": "1年授权",
        "status": "部分匹配",
        "match_details": {
            "match_source_name": "CNKI代理商",
            "match_source_id": "Supplier-CNKI-001",
            "matched_title": "CNKI期刊数据库使用权限",
            "matched_isbn": null,
            "matched_quantity": null,
            "matched_price_unit": 150000.00,
            "match_time": "2025-08-29T17:30:00Z"
        },
        "notes": "已获得期刊库报价，核心数据库部分仍在等待报价。"
    },
    {
        "requirement_id": "REQ-015",
        "item_type": "图书",
        "required_title": "C++ Primer Plus（第六版）",
        "required_author": "Stephen Prata",
        "required_isbn": "978-7-115-32214-7",
        "required_publisher": "人民邮电出版社",
        "required_quantity": 250,
        "required_edition": "中译本",
        "status": "匹配失败",
        "match_details": {
            "fail_reason": "市场上该版本已绝版，建议采购最新版或替代教材。",
            "last_attempt_time": "2025-08-30T09:50:00Z"
        },
        "notes": "需与项目经理确认是否可更换版本。"
    },
    {
        "requirement_id": "REQ-016",
        "item_type": "图书",
        "required_title": "机器学习",
        "required_author": "周志华",
        "required_isbn": "978-7-302-42328-7",
        "required_publisher": "清华大学出版社",
        "required_quantity": 100,
        "required_edition": "2016年版",
        "status": "未匹配",
        "match_details": null,
        "notes": "该书为经典教材，需确认库存和折扣。"
    },
    {
        "requirement_id": "REQ-017",
        "item_type": "音像制品",
        "required_title": "纪录片：《大国重器》",
        "required_author": null,
        "required_isbn": null,
        "required_publisher": "中央电视台",
        "required_quantity": 3,
        "required_edition": "DVD高清版",
        "status": "已匹配",
        "match_details": {
            "match_source_name": "中国国际电视总公司",
            "match_source_id": "Supplier-CCTV-001",
            "matched_title": "《大国重器》纪录片套装",
            "matched_isbn": null,
            "matched_price_unit": 890.00,
            "match_time": "2025-08-29T15:00:00Z"
        },
        "notes": "已联系CCTV音像出版部门获得授权和报价。"
    },
    {
        "requirement_id": "REQ-018",
        "item_type": "图书",
        "required_title": "人类简史",
        "required_author": "尤瓦尔·赫拉利",
        "required_isbn": "978-7-5086-4735-9",
        "required_publisher": "中信出版社",
        "required_quantity": 180,
        "required_edition": "中文版",
        "status": "部分匹配",
        "match_details": {
            "match_source_name": "京东供应商",
            "match_source_id": "Supplier-JD-001",
            "matched_title": "人类简史：从动物到上帝",
            "matched_isbn": "978-7-5086-4735-9",
            "matched_quantity": 100,
            "matched_price_unit": 55.00,
            "match_time": "2025-08-30T10:30:00Z"
        },
        "notes": "供应商库存不足，先采购100本，剩余部分继续寻找。"
    },
    {
        "requirement_id": "REQ-019",
        "item_type": "内容",
        "required_title": "《故宫博物院藏品目录》授权",
        "required_author": null,
        "required_isbn": null,
        "required_publisher": "故宫博物院",
        "required_quantity": 1,
        "required_edition": "电子版",
        "status": "未匹配",
        "match_details": null,
        "notes": "需联系官方授权部门获取报价，用于电子图书馆系统。"
    },
    {
        "requirement_id": "REQ-020",
        "item_type": "图书",
        "required_title": "高等数学（第七版）",
        "required_author": "同济大学数学系",
        "required_isbn": "978-7-040-39420-5",
        "required_publisher": "高等教育出版社",
        "required_quantity": 400,
        "required_edition": "上下册",
        "status": "已匹配",
        "match_details": {
            "match_source_name": "高等教育出版社直供",
            "match_source_id": "Supplier-HEP-001",
            "matched_title": "高等数学（第七版）上下册",
            "matched_isbn": "978-7-040-39420-5",
            "matched_price_unit": 75.00,
            "match_time": "2025-08-28T11:00:00Z"
        },
        "notes": "经典教材，出版社直供价格有优势。"
    },
    // 以下是更多随机生成的真实感数据 (共200条以上)
    ...Array.from({ length: 190 }, (_, i) => {
        const id = i + 21;
        const types = ['图书', '期刊', '电子资源', '音像制品', '内容'];
        const statuses = ['未匹配', '已匹配', '部分匹配', '匹配失败'];
        const publishers = ['清华大学出版社', '人民邮电出版社', '中信出版社', '机械工业出版社', '电子工业出版社', '中华书局', '商务印书馆', '人民文学出版社', '生活·读书·新知三联书店'];
        const authors = ['王力', '李华', '陈明', '张伟', '刘飞', '周勇', '孙强', '马杰', '吴静', '郑凯'];
        const randomType = types[Math.floor(Math.random() * types.length)];
        const randomStatus = statuses[Math.floor(Math.random() * statuses.length)];
        const requiredTitle = `随机生成图书/资源-${id}-${Math.random().toString(36).substring(7)}`;
        const requiredAuthor = randomType === '图书' ? authors[Math.floor(Math.random() * authors.length)] : null;
        const requiredISBN = randomType === '图书' ? `978-7-${Math.floor(Math.random() * 900) + 100}-${Math.floor(Math.random() * 900000000) + 100000000}` : null;
        const requiredPublisher = randomType === '图书' ? publishers[Math.floor(Math.random() * publishers.length)] : null;
        const requiredQuantity = Math.floor(Math.random() * 100) + 1;
        const requiredEdition = `第${Math.floor(Math.random() * 5) + 1}版`;

        let match_details = null;
        let notes = `这是一条用于测试的采购需求，ID: ${id}。`;
        if (randomStatus === '已匹配' || randomStatus === '部分匹配') {
            match_details = {
                match_source_name: `供应商${Math.floor(Math.random() * 20) + 1}`,
                matched_title: `${requiredTitle}（已匹配）`,
                matched_author: requiredAuthor,
                matched_isbn: requiredISBN,
                matched_price_unit: (Math.random() * 500 + 20).toFixed(2),
                match_time: new Date(new Date().getTime() - Math.floor(Math.random() * 10) * 24 * 60 * 60 * 1000).toISOString()
            };
            if (randomStatus === '部分匹配') {
                match_details.matched_quantity = Math.floor(requiredQuantity * 0.5);
                notes = `已匹配部分数量 ${match_details.matched_quantity}，剩余数量待定。`;
            }
        } else if (randomStatus === '匹配失败') {
            match_details = {
                fail_reason: "该项无货或供应商报价过高。",
                last_attempt_time: new Date(new Date().getTime() - Math.floor(Math.random() * 5) * 24 * 60 * 60 * 1000).toISOString()
            };
            notes = "匹配失败，需重新评估采购方案。";
        }

        return {
            "requirement_id": `REQ-${String(id).padStart(3, '0')}`,
            "item_type": randomType,
            "required_title": requiredTitle,
            "required_author": requiredAuthor,
            "required_isbn": requiredISBN,
            "required_publisher": requiredPublisher,
            "required_quantity": requiredQuantity,
            "required_edition": requiredEdition,
            "status": randomStatus,
            "match_details": match_details,
            "notes": notes
        };
    })
];

export default mockOutsourceList;


// WEBPACK FOOTER //
// ./src/dataJson/mockOutsourceList.js